import { render, staticRenderFns } from "./stocksBroker.vue?vue&type=template&id=ed44c4e4&scoped=true&"
import script from "./stocksBroker.vue?vue&type=script&lang=ts&"
export * from "./stocksBroker.vue?vue&type=script&lang=ts&"
import style0 from "./stocksBroker.vue?vue&type=style&index=0&id=ed44c4e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed44c4e4",
  null
  
)

export default component.exports